import type { SystemHealthView } from '@solar/contracts';

import { apiClient } from '../../lib/api-client';

export const systemHealthApi = {
  get(): Promise<SystemHealthView> {
    return apiClient.get('/admin/system-health');
  },
};
